export const COLOR_MODE_STORAGE_KEY = 'color-mode';
export const INITIAL_COLOR_MODE_CSS_PROP = '--initial-color-mode';

export const COLORS = {
  text: {
    light: 'black',
    dark: 'white'
  },
  background: {
    light: 'white',
    dark: '#001d4a'
  },
  menuBackground: {
    light: '#dbdfe3',
    dark: 'black'
  },
  resumeBackground: {
    light: '#dbdfe3',
    dark: '#000A19'
  },
  articleBackground: {
    light: 'white',
    dark: '#0E141B'
  },
  primary: {
    light: '#021D44',
    dark: 'white'
  },
  primaryFlipped: {
    light: 'white',
    dark: '#021D44'
  },
  secondary: {
    light: '#ff3e55',
    dark: '#ff3e55'
  },
  accent: {
    light: '#006cc0',
    dark: '#006cc0'
  },
  /* imageBackground: {
    light: '#d8d8d8',
    dark: '#d8d8d8'
  }, */
  textAccentDarkest: {
    light: '#777777',
    dark: '#777777'
  },
  textAccentMiddle: {
    light: 'rgba(2,29,68,0.75)',
    dark: 'rgba(250,250,250,0.75)'
  },
  /* grayLess: {
    light: '#d8d8d8',
    dark: '#d8d8d8'
  },
  grayLeast: {
    light: '#d8d8d8',
    dark: '#d8d8d8'
  }, */
  lightBorder: {
    light: 'rgba(0, 0, 0, 0.3)',
    dark: 'rgba(255, 255, 255, 0.3)'
  },
  paginationBtn: {
    light: '#dbdfe3',
    dark: '#4e617c'
  },
  articleBg: {
    light: 'white',
    dark: '#0f141a'
  },
  blogHeadBg: {
    light: '#d8d8d8',
    dark: '#001d4a'
  }
};